import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
    name: string;
    nickName: string;
    picture: string;
    email: string;
    emailVerified: boolean;
    userIsoCode: string;
    phone: string;
    phoneVerified: boolean;
    callBackRequest: boolean;
    profileStatus: string;
    degreePursue: string;
    id: string;
    referralCode?: string | null;
}

const initialState: UserState = {
    name: '',
    nickName: '',
    picture: '',
    email: '',
    emailVerified: false,
    userIsoCode: '',
    phone: '',
    phoneVerified: false,
    callBackRequest: false,
    profileStatus: '',
    degreePursue: 'master',
    id: ''
    ,referralCode: null
};

const userSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        setUserInfo(state, action: PayloadAction<UserState>) {
            return { ...state, ...action.payload };
        },
        updateUserField<K extends keyof UserState>(state:any, action: PayloadAction<{ key: K; value: UserState[K] }>) {
            state[action.payload.key] = action.payload.value;
        },
        setUserId(state, action: PayloadAction<string>){
            state.id = action.payload;
        },
        clearUserInfo() {
            return initialState;
        },
    },
});

export const { setUserInfo, updateUserField, clearUserInfo } = userSlice.actions;
export default userSlice.reducer;
